module.exports = __webpack_public_path__ + "static/media/LuxWindows.16d256ad.svg";